import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks";
import { EditIcon } from "../../../../../ui/icons/edit";
import { TrashIcon } from "../../../../../ui/icons/trash";
import { formatterDate, optionsFormatter, SCEvaluationResultOptions, SCTestReportResultOptions } from "../../../../../utils";
import { GetAllSampleCollection, resetSampleCollectionCreationRequest, resetSampleCollectionDeleteStatus, resetSampleCollectionUpdateRequest, SampleCollectionDelete, setSampleCollectionIdentifier, setSampleCollectionIdToUpdate, setSampleCollectionUpdateRequest } from "./slice";
import Button from "../../../../../ui/molecules/button";
import { RoundedPlusIcon } from "../../../../../ui/icons/RoundedPlusIcon";
import { PopupForm } from "../../../../../ui/organisms/popupForm";
import { IVGestionePrelieviAddPopup } from "./addPopup";
import { SampleCollectionDTO, SampleCollectionUpdateDTO } from "./dataservice/dto";
import { IVGestionePrelieviEditPopup } from "./editPopup";
import { Alert } from "../../../../../ui/organisms/alert";

export function IVGestionePrelieviEdit() {
    const dispatch = useAppDispatch()
    const sampleCollectionState = useAppSelector(state => state.sampleCollection)
    const assignmentState = useAppSelector(state => state.assignment)
    const userState = useAppSelector(state => state.users)
    const [showPopupAdd, setShowPopupAdd] = useState<boolean>(false)
    const [showPopupEdit, setShowPopupEdit] = useState<boolean>(false)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [sampleToDel, setSampleToDel] = useState<string | null>(null)

    const handleOnEdit = (sample: SampleCollectionDTO) => {
        dispatch(setSampleCollectionIdentifier(sample.identifierCode))
        dispatch(setSampleCollectionIdToUpdate(sample.id))
        dispatch(setSampleCollectionUpdateRequest({
            samplingTime: sample.samplingTime,
            samplingDate: sample.samplingDate,
            materialSampled: sample.materialSampled,
            lotNumber: sample.lotNumber,
            collectionUnit: sample.collectionUnit,
            laboratoryId: sample.laboratoryId,
            note: sample.note,
            plannedSampling: sample.plannedSampling,
            samplingCompleted: sample.samplingCompleted,
            samplingResult: sample.samplingResult,
            principlesFound: sample.principlesFound,
            multiresiduale: sample.multiresiduale,
            fosetylAl: sample.fosetylAl,
            glifosate: sample.glifosate,
            ogm: sample.ogm,
            cloratiPerclorati: sample.cloratiPerclorati,
            clormequatMepiquat: sample.clormequatMepiquat,
            other: sample.other,
            otherDetail: sample.otherDetail,
            testReportNumber: sample.testReportNumber,
            testReportDate: sample.testReportDate,
            entryProtocolId: sample.entryProtocolId !== null ? sample.entryProtocolId : undefined,
            testReportResult: sample.testReportResult,
            evaluationDate: sample.evaluationDate,
            officerId: userState.findMeResponse.id
        } as SampleCollectionUpdateDTO))
        setShowPopupEdit(true)
    }

    useEffect(() => {
        dispatch(GetAllSampleCollection({
            itemsPerPage: 0,
            page: 0,
            inspectionVisitId: assignmentState.inspectionVisitIdToUpdate
        }))
    }, [])

    useEffect(() => {
        if (sampleCollectionState.sampleCollectionCreationStatus === 'successfully' ||
            sampleCollectionState.sampleCollectionUpdateStatus === 'successfully' ||
            sampleCollectionState.sampleCollectionDeleteStatus
        ) {
            dispatch(GetAllSampleCollection({
                itemsPerPage: 0,
                page: 0,
                inspectionVisitId: assignmentState.inspectionVisitIdToUpdate
            }))
        }
    }, [sampleCollectionState.sampleCollectionCreationStatus,
    sampleCollectionState.sampleCollectionUpdateStatus,
    sampleCollectionState.sampleCollectionDeleteStatus
    ])

    useEffect(() => {
        if (sampleCollectionState.sampleCollectionDeleteStatus === 'successfully') {
            dispatch(resetSampleCollectionDeleteStatus())
            setShowAlert(false)
        }
    }, [sampleCollectionState.sampleCollectionDeleteStatus])

    return (
        <div style={{ padding: '24px' }}>

            <div className="pb-[24px]">
                <table id="list-table" className="w-[100%] assignment-table">
                    <thead className="h-[52px] uppercase">
                        <tr>
                            <th style={{ borderTopLeftRadius: '8px' }}></th>
                            <th className="width-[130px]" style={{ textAlign: 'center' }}>Codice di Identificazione del Verbale di Campionamento</th>
                            <th className="width-[130px]">Data Prelievo</th>
                            <th className="width-[130px]">Orario Prelievo</th>
                            <th className="width-[130px]">Busta Analizzare</th>
                            <th className="width-[100px]">Busta Cliente</th>
                            <th className="width-[130px]">Busta 3 da custodire</th>
                            <th className="width-[130px]">Busta 4 da custodire</th>
                            <th className="width-[130px]">Materiale prelevato</th>
                            <th className="width-[130px]">Protocollo Rapporto di prova</th>
                            <th className="width-[130px]">Laboratorio</th>
                            <th className="width-[130px]">Esito</th>
                            <th className="width-[130px]">Principi attivi riscontrati</th>
                            <th className="width-[130px]">Data Valutazione</th>
                            <th className="width-[130px]">Utente Valutazione</th>
                            <th style={{ borderTopRightRadius: '8px', width: '40px' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            sampleCollectionState.getAllSampleCollectionResponse?.data.map((sample, index) =>
                                <tr
                                    key={index}
                                    style={{
                                        color: '#4D797F',
                                        background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                    }}
                                >
                                    <td>
                                        <div className="flex justify-content-center align-items-center gap-[10px]">
                                            <button onClick={() => handleOnEdit(sample)} className="tooltip-container">
                                                <EditIcon color={"#FF941A"} size={20} />
                                                <span className="tooltip-text">Modifica prelievo</span>
                                            </button>
                                            <button onClick={() => {
                                                setSampleToDel(sample.id)
                                                setShowAlert(true)
                                            }} className="tooltip-container">
                                                <TrashIcon color={"#DB0700"} size={20} />
                                                <span className="tooltip-text">Cancella prelievo</span>
                                            </button>

                                        </div>
                                    </td>
                                    <td>{sample.identifierCode}</td>
                                    <td>{formatterDate(sample.samplingDate)}</td>
                                    <td>{sample.samplingTime}</td>
                                    <td>{sample.envelopeToLaboratory}</td>
                                    <td>{sample.envelopeToCustomer}</td>
                                    <td>{sample.firstEnvelopeToCodex}</td>
                                    <td>{sample.secondEnvelopeToCodex}</td>
                                    <td>{sample.materialSampled}</td>
                                    <td>{sample.entryProtocolInfo}</td>
                                    <td>{sample.laboratoryInfo}</td>
                                    <td>{optionsFormatter(sample.samplingResult, SCEvaluationResultOptions) ?? optionsFormatter(sample.testReportResult, SCTestReportResultOptions)}</td>
                                    <td>{sample.principlesFound}</td>
                                    <td>{formatterDate(sample.evaluationDate)}</td>
                                    <td>{sample.officerInfo}</td>
                                    <td></td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>

            <div style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                <Button
                    variant="solid"
                    color="dimgrey"
                    size="md"
                    iconPosition="left"
                    icon={<RoundedPlusIcon />}
                    label="Aggiungi prelievo"
                    onClick={() => setShowPopupAdd(true)}
                />
            </div>

            {
                showPopupAdd && (
                    <PopupForm headerGreen title="Aggiungi Prelievo" close={() => {
                        dispatch(resetSampleCollectionCreationRequest())
                        setShowPopupAdd(false)
                    }}>
                        <IVGestionePrelieviAddPopup close={() => {
                            dispatch(resetSampleCollectionCreationRequest())
                            setShowPopupAdd(false)
                        }} />
                    </PopupForm>
                )
            }

            {
                showPopupEdit && (
                    <PopupForm headerGreen title="Modifica Prelievo" close={() => {
                        dispatch(resetSampleCollectionUpdateRequest())
                        setShowPopupEdit(false)
                    }}>
                        <IVGestionePrelieviEditPopup close={() => {
                            dispatch(resetSampleCollectionUpdateRequest())
                            setShowPopupEdit(false)
                        }} />
                    </PopupForm>
                )
            }
            {
                (showAlert && sampleToDel) && (
                    <Alert title="Conferma operazione" close={() => setShowAlert(false)} headerGreen={true}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3 mt-4">
                                <div>
                                    Sei sicuro di voler eliminare il prelievo?
                                </div>
                            </div>
                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button
                                    variant="outline"
                                    color="dimgrey"
                                    iconPosition="off"
                                    label="Chiudi finestra"
                                    size="md"
                                    onClick={() => setShowAlert(false)}
                                />

                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color={'red'}
                                        iconPosition="off"
                                        label={'Elimina'}
                                        size="md"
                                        onClick={() => dispatch(SampleCollectionDelete(sampleToDel))}
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }
        </div>
    )
}